import { Routes, Route } from "react-router-dom";
import { AuditoriaPage } from "./pages/AuditoriaPage";

export const AuditoriaNavigation = () => {
  return (
    <Routes>
      <Route index element={<AuditoriaPage />} />
    </Routes>
  );
};
